<template>
  <div :class="widthSearch == true ? 'narrow with-search' : 'narrow'">
    <el-row v-for="(row, index) in narrows" :key="index">
      <el-col :span="24 / row.length" v-for="filter in row" :key="filter.label">
        <dl class="group">
          <dt>{{ filter.label }}</dt>
          <dd>
            <ul>
              <li
                v-for="item in filter.items"
                :key="item.key"
                :class="
                  isSelected(filter.label, item.key) ? 'active' : 'unactive'
                "
              >
                <a @click.stop="select(filter.label, item)">
                  <span v-if="item.label">
                    {{ item.label }}
                    <span v-if="item.numberFun">({{ item.number }})</span>
                  </span>
                  <flag :name="item.flag" :size="14" v-else></flag>
                </a>
                <span
                  v-if="isSelected(filter.label, item.key)"
                  @click="unselect(filter.label)"
                >
                  <i class="el-icon-close" />
                </span>
              </li>
            </ul>
          </dd>
        </dl>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  props: {
    narrows: Array,
    initFilter: null,
    widthSearch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  mounted() {
    for (let row of this.narrows) {
      for (let filter of row) {
        for (let item of filter.items) {
          if (item.numberFun) {
            this.computeNumber(item);
          }
          if (this.initFilter && typeof this.initFilter == "string") {
            if (item.key == this.initFilter) {
              this.selected.push({ filterLabel: filter.label, item: item });
            }
          }
          if (this.initFilter && typeof this.initFilter == "object") {
            if (this.initFilter.includes(item.key)) {
              this.selected.push({ filterLabel: filter.label, item: item });
            }
          }
        }
      }
    }
  },
  created() {},
  methods: {
    async computeNumber(item) {
      const self = this;
      if (item.numberFun) {
        let res = await item.numberFun();
        let number = res.data > 9999 ? "9999+" : res.data;
        Vue.set(item, "number", number);
        // 广播接收
        for (const emitName of item.emitNames) {
          self.$eventHub.$on(emitName, async () => {
            let res2 = await item.numberFun();
            let number2 = res2.data > 9999 ? "9999+" : res2.data;
            Vue.set(item, "number", number2);
          });
        }
      }
    },
    select(filterLabel, item) {
      let sd = this.selected.find((s) => s.filterLabel == filterLabel);
      if (sd) {
        sd.item = item;
      } else {
        this.selected.push({ filterLabel: filterLabel, item: item });
      }
      this.$emit(
        "narrowSelect",
        this.selected.map((sd) => sd.item.condition)
      );
    },
    unselect(filterLabel) {
      let idx = this.selected.findIndex((sd) => sd.filterLabel === filterLabel);
      if (idx >= 0) {
        this.selected.splice(idx, 1);
      }
      this.$emit(
        "narrowSelect",
        this.selected.map((sd) => sd.item.condition)
      );
    },
    isSelected(filterLabel, key) {
      return this.selected.find(
        (sd) => sd.filterLabel == filterLabel && sd.item.key == key
      );
    },
  },
};
</script>

<style scoped>
.narrow {
  background: #fff;
  /* padding: 7px 7px 15px 7px; */
  padding: 7px;
  border-top: 2px solid #b29d6b;
  box-shadow: 5px 5px 5px 0px #eeeeee;
  /* border-radius: 5px; */
}
.with-search {
  /* border-bottom-left-radius: 0px; */
  /* border-bottom-right-radius: 0px; */
}
.narrow dl.group {
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.05); */
  padding-bottom: 7px;
  padding-top: 7px;
  margin: 0;
  height: 20px;
  clear: both;
  margin: 0 10px;
}

.narrow dl.group dt {
  width: 100px;
  text-align: right;
  font-weight: bold;
  font-size: 14px;
  float: left;
  color: #606266;
}

.narrow dl.group dd {
  margin-left: 100px;
  font-size: 14px;
}

.narrow dl.group dd ul {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-left: 20px;
}

.narrow dl.group dd ul li {
  float: left;
  padding-right: 7px;
}

.narrow a {
  cursor: pointer;
}

.narrow li.active a {
  color: #6b1b13;
}

.narrow li.active .fa-icon {
  left: 0px;
  color: #777;
  height: 11px;
}

.narrow hr {
  height: 0px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 0;
  margin: 0;
}

.narrow-wrapper {
  background-color: #e9e8e6;
}

.filter-close {
  font-size: 10px;
}
</style>